module.exports = __webpack_public_path__ + "static/media/lakshmimachineworks.8d744fe6.svg";